import React from 'react';
import { useState, useEffect, useLayoutEffect } from 'react';
import { Document } from "shared/models/site/document"
import { DocumentType as IDocumentTypeItem } from 'shared/models/site/document-type';
import RelatedDocuments from './RelatedDocuments';

import {
    Button
    , ModalBody
    , FormGroup
    , Label
    , Input
    , Row
    , Col,
    FormFeedback
} from 'reactstrap';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import Toggle from 'bootstrap-switch-button-react';
import { ToolTipButton, ToolTipLabel } from "components/menu/Labels";
import './DocumentAdmin.css'
import { toISOLocalDate } from "shared/models/mapping/mapping";
import useSelector from 'hooks/useSelector';
import { getDocumentTypeFromId } from 'shared/services/documentTypeService';
import { DocumentAddEditState, documentAddEditState } from './AddEditDocumentState'
import { PageView } from './AddEditDocument';
import { RelatedDocumentChips } from './RelatedDocuments';
import './DocumentAdmin.css'
import InfoModal from 'components/ui/InfoModal';
import { DocumentReviewPeriodEnum, documentReviewPeriodDisplay, getMonths } from "shared/enums/document-review-period-enum"
import { DocumentTypeEnum } from 'shared/enums/document-type-enum';
import { isRuleBookDocumentType, isRulebookDocument } from 'helpers/filters';
import { RelatedDocument } from 'shared/models/site/related-document';
import { getAllDocumentDepartments, IDocumentValidationRequest, validateDocument } from 'shared/services/railDocumentsApi';
import { RelatedRulebookDocumentViewTraditional, RelatedRulebookDocumentViewCBTC } from 'components/ui/DocumentRules';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { getUserExistingRulebookMode } from '../../../../shared/store/applicationState';
import { RulebookNameToEnum, RulebookModeEnum } from '../../../../shared/enums/rulebook-mode-enum';
import { Typeahead as TypeaheadComponent } from 'react-bootstrap-typeahead';
import Typeahead from 'react-bootstrap-typeahead/types/core/Typeahead';
import { List, StringListItem } from '../../../ui/Lists';
import { DocumentDepartment, DocumentDepartmentModel } from '../../../../shared/models/api/models';
import Chip from '@mui/material/Chip';
import { LabelledCheckbox } from '../../../ui/LabelledCheckbox';
import { ConfirmationBox, IConfirmProps } from '../../../ui/ConfirmationBox';
import '../../../ui/ConfirmationBox.css';
import { UserDepartmentEnum } from '../../../../shared/enums/user-department-enum';
import * as api from 'shared/services/reportingApi';
import { UserListItem } from '../../reporting/UserDocumentsReportingView';
import { User } from 'shared/services/reportingApi';

// A first attempt at page validation
type PageValidation = {
    isValid?: boolean,
    titleValidation?: FieldValidation,
    documentNumberValidation?: FieldValidation,
    fileValidation?: FieldValidation,
    documentTypeValidation?: FieldValidation,
    effectiveDateValidation?: FieldValidation,
    expireDateValidation?: FieldValidation,
    versionNumberValidation?: FieldValidation,
    subTypeValidation?: FieldValidation,
    rescindDocumentReasonValidation?: FieldValidation,
    documentDepartmentValidation?: FieldValidation
}

type FieldValidation = {
    display: boolean,
    message: string
}

interface IChipsProps<T> {
    values: T[],
    removeItem: (item: T) => void,
    prefix?: any
}

const Chips = (props: IChipsProps<string>) =>
    <>
        {props.values &&
            props.values.map(val =>
                <Chip
                    key={val}
                    onDelete={() => { props.removeItem(val); }}
                    label={<>
                        <b>{props.prefix ? props.prefix + ": " : ""}</b>{val}
                    </>}
                />
            )
        }
    </>;

const UserChips = (props: IChipsProps<api.User>) =>
    <>
        {props.values &&
            props.values.map(usr =>
                <Chip
                    key={usr.id}
                    onDelete={() => { props.removeItem(usr); }}
                    label={<>
                        <b>{props.prefix ? props.prefix + ": " : ""}</b>{usr.fullName}
                    </>} />
            )
        }
    </>;

const requiredValidation = (field?: string) => ((field || '').trim() === '')
const minLengthValidation = (minLength: number, field?: string) => (field && field.length < minLength)
const validateForm = (doc: Document, view: PageView, display: boolean, docTypes: IDocumentTypeItem[]): PageValidation => {
    //Display will set if the validation will appear during editing the form or on submit

    let docType = {} as IDocumentTypeItem;
    if (docTypes.length > 0) {
        docType = docTypes[0];
        if (typeof (doc.subTypeId) === 'number') {
            var subtypeIndex = docType.children?.findIndex(t => t.typeId == doc.subTypeId);
            if (docType.children !== undefined && typeof (subtypeIndex) === 'number') {
                docType = docType.children[subtypeIndex];
            }
        }
    }

    var pv: PageValidation = {
        titleValidation: validateTitle(doc, view, display, docType),
        documentNumberValidation: validateDocumentNumber(doc, view, display, docType),
        fileValidation: validateFile(doc, view, display),
        documentTypeValidation: requiredValidation(doc.typeLabel) ? { display: display, message: "Document type is required" } : undefined,
        effectiveDateValidation: requiredValidation(doc.effectiveFromDate) ? { display: display, message: "Effective date is required" } : undefined,
        versionNumberValidation: validateVersionNumber(doc, view, display, docType),
        subTypeValidation: doc.subTypeLabel == null ? { display: display, message: "Document sub-type is required" } : undefined,
        rescindDocumentReasonValidation: view === PageView.Rescind && !doc.rescindDocumentReason ? { display: display, message: "Reason for rescinding document is required" } : undefined,
        documentDepartmentValidation: validateDocumentDepartment(doc, display)
    }

    pv.isValid = !(pv.titleValidation) &&
        !(pv.documentNumberValidation) &&
        !(pv.fileValidation) &&
        !(pv.documentTypeValidation) &&
        !(pv.effectiveDateValidation) &&
        !(pv.expireDateValidation) &&
        !(pv.versionNumberValidation) &&
        !(pv.rescindDocumentReasonValidation) &&
        !(pv.documentDepartmentValidation)
    return pv;
}

const validateTitle = (doc: Document, view: PageView, display: boolean, docType: IDocumentTypeItem): FieldValidation | undefined => {
    if (requiredValidation(doc.title)) {
        return { display: display, message: "Document title is required" } as FieldValidation;
    }

    if (typeof (docType?.documentTitleValidation) === 'string' && typeof (doc.title) === 'string') {
        let re = new RegExp(docType.documentTitleValidation);
        if (!re.test(doc.title)) {
            let fmt = docType?.documentTitleDefault.replaceAll('{', '').replaceAll('}', '');
            return { display: display, message: `Document title required prefix: ${fmt}` } as FieldValidation;
        }

    }

    return undefined;
}

const validateDocumentNumber = (doc: Document, view: PageView, display: boolean, docType: IDocumentTypeItem): FieldValidation | undefined => {
    if (requiredValidation(doc.documentNumber)) {
        return { display: display, message: "Document number is required" } as FieldValidation;
    }

    if (minLengthValidation(7, doc.documentNumber)) {
        return { display: display, message: "Document number should be at least 7 characters" } as FieldValidation;
    }

    if (typeof (docType?.documentNumberValidation) === 'string' && typeof (doc.documentNumber) === 'string') {
        let re = new RegExp(docType.documentNumberValidation);
        if (!re.test(doc.documentNumber)) {
            let fmt = docType?.documentNumberDefault.replaceAll('{', '').replaceAll('}', '');
            return { display: display, message: `Document number required format: ${fmt}` } as FieldValidation;
        }
    }

    return undefined;
}

const validateVersionNumber = (doc: Document, view: PageView, display: boolean, docType: IDocumentTypeItem): FieldValidation | undefined => {
    if (requiredValidation(doc.versionNumber)) {
        return { display: display, message: "Version number is required" } as FieldValidation;
    }

    let re = /^[0-9]+\.[0-9]+$/;
    if (!re.test(doc.versionNumber || "")) {
        return { display: display, message: "Version number must be decimal format, e.g. 1.0" } as FieldValidation;
    }

    return undefined;
}

const validateFile = (doc: Document, view: PageView, display: boolean): FieldValidation | undefined => {
    if (view == PageView.Edit) {
        return undefined;
    }

    if (!doc.file) {
        return { display: display, message: "File is required" };
    }

    if (!doc.file.name.toLocaleLowerCase().endsWith(".pdf")) {
        return { display: display, message: "File must be a PDF" };
    }

    return undefined;
}

const validateDocumentDepartment = (doc: Document, display: boolean) => {
    if (doc.departments === undefined || doc.departments?.length === 0) {
        return { display: display, message: "Document department required" } as FieldValidation;
    }

    return undefined;
}

const getDefaultTitle = (docType?: IDocumentTypeItem) => {
    let title = '';
    if (docType?.documentTitleDefault != undefined) {
        title = documentTitleDefaultFormat(docType.documentTitleDefault);
    }
    return title;
}

const getDefaultDocumentNumberTitle = (docType?: IDocumentTypeItem) => {
    let documentNumber = '';
    if (docType?.documentNumberDefault != undefined) {
        documentNumber = documentTitleDefaultFormat(docType.documentNumberDefault);
    }
    return documentNumber;
}

const documentTitleDefaultFormat = (str: string) => {
    let today = new Date();
    let yy = today.toISOString().substring(2, 4);
    let mm = today.toISOString().substring(5, 7);

    str = str.replaceAll('{YY}', yy);
    str = str.replaceAll('{MM}', mm);
    return str;
}

const toolTip = {
    expiryDate: <>The date/time that this document <br />should cease to be current and applicable </>,
    documentNumber: <>This is the unique identifier of the document.<br />
        It will be either the 1Doc number, or;<br />
        ON YY-XXX for Operating Notices;<br />
        OI YY-XXX for Operating Instructions;<br />
        ROME YY-XXX for Memos;<br />
        RCOI YY-XXX for Rail Control Operating Instructions;<br />
        TGI YY-XXX for Track General Instructions;<br />
        TEI YY-XXX for Track Engineering Instructions;<br />
        SGI YY-XXX for Signalling General Instructions.</>,
    versionNumber: <>This is the unique version of the document; <br />will be the 1Doc version number if applicable</>,
    effectiveDate: 'The date/time that this document will be valid',
    reviewPeriod: <>After this period of time the<br /> user should re-read and acknowledge the document</>,
    releaseNotes: <>Describes document summary <br /> of change from the last version</>,
    rescindDocumentReason: <>Please specify why the document <br /> is being rescinded</>
}


const ToggleButton = ({ isOpen, onClick, isInvalid }: any) => (
    <button
        className="toggle-button"
        onClick={onClick}
        onMouseDown={(e: any) => {
            // Prevent input from losing focus.
            e.preventDefault();
        }}>
        {isInvalid ? undefined : isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
    </button>
);


const RuleBookModuleId: number = 1;
const NonRuleBookModuleId: number = 2;
const CBTCId: number = 2;
const TraditionalId: number = 1;
const BothId: number = 3;



// WIP would like to split out these sections again now that the form works better
const DocumentTypeSelect = (props: { document: Document, onChange: (e: any) => void }) => {
    return (<>
        <div>
            <FormGroup tag="fieldset" className="form-check-inline pt-2"    >
                <FormGroup check>
                    <Label check>
                        <Input type="radio" value={NonRuleBookModuleId} onChange={props.onChange} checked={props.document.documentModule !== RuleBookModuleId} name="docTypeRadio" />{' '}
                        Rail Document
                    </Label>
                </FormGroup>
                <FormGroup check>
                    <Label check>
                        <Input type="radio" value={RuleBookModuleId} onChange={props.onChange} checked={props.document.documentModule === RuleBookModuleId} name="docTypeRadio" />{' '}
                        Rulebook
                    </Label>
                </FormGroup>
            </FormGroup>
        </div></>
    );
}

const RelatedDocumentsSection = (props: { document: Document, deleteAction: (id: number) => void }) => {
    const [showRelatedDocuments, setShowRelatedDocuments] = useState(false);

    // Use mode to choose the RelatedRulebookDocumentView here

    return (
        <>
            <h3>Related documents (optional)</h3>
            <FormGroup>
                <div className="pb-2">
                    <RelatedDocumentChips documents={props.document.relatedDocuments || []} deleteAction={props.deleteAction} />
                </div>
                <Button
                    onClick={() => setShowRelatedDocuments(true)}
                    disabled={!RelatedRulebookDocumentViewTraditional.documentTypes.some((t => t.id === props.document.typeId || t.subTypes?.some(st => st.id === props.document.typeId))) ||
                        !RelatedRulebookDocumentViewCBTC.documentTypes.some((t => t.id === props.document.typeId || t.subTypes?.some(st => st.id === props.document.typeId)))}
                >Manage Documents</Button>
                <RelatedDocuments
                    isOpen={showRelatedDocuments}
                    closeAction={() => setShowRelatedDocuments(false)}
                    document={props.document}
                />
            </FormGroup>
            <hr />
        </>)
}


const DocumentFileUploadSection = (props: { document: Document, viewType: PageView, pageValidation: PageValidation, onFileChange: (e: any) => void }) => {
    const existingFile = (props.viewType === PageView.NewVersion || props.viewType === PageView.Rescind) ?
        props.document.file ? props.document.file.name : undefined :
        props.document.file ? props.document.file.name : props.document.fileName;


    const FileInput = () => (
        <FormGroup>
            <Label for="documentUpload">Select file:
                <Input
                    type="file"
                    name="file"
                    className={`d-none ${props.pageValidation.fileValidation?.display ? 'invalid-field' : ''}`}
                    key="documentupload"
                    id="documentUpload"
                    accept="application/pdf"
                    onChange={props.onFileChange} />
                <div className="browse-button">Browse</div>
            </Label>
        </FormGroup>
    );

    const renderSwitch = () => {
        switch (props.viewType) {
            case PageView.NewVersion:
            case PageView.AddNew:
            case PageView.Rescind:
                return (<>
                    {
                        existingFile ?
                            <> <Label>Selected file:&nbsp;{existingFile} </Label> <Button className="btn-secondary" onClick={() => props.onFileChange(undefined)}> Remove </Button></> :
                            <FileInput />
                    }
                    {props.pageValidation.fileValidation?.display ?
                        <div className='validation-text'>{props.pageValidation.fileValidation?.message}</div>
                        : <></>}
                </>
                )
            case PageView.Edit:
                return (<Label>Exising file:&nbsp;{existingFile} </Label>);

            default:
                break;
        }
    }
    return (
        <>
            <hr />
            <h3>File upload</h3>
            {renderSwitch()}
        </>
    );
};

export const FirstPage = (props: {
    viewType: PageView,
    documentId?: number,
    closeAction: () => void,
    nextAction: () => void,
    validateAction?: (x: boolean) => void
}) => {
    const [documentType, setDocumentType] = useState([] as Array<IDocumentTypeItem>);
    const [subCategories, setSubCategories] = useState([] as Array<IDocumentTypeItem>);
    const [document, setDocument] = useState({} as Document);
    const [pageValidation, setPageValidation] = useState({} as PageValidation);
    const [originalTitle, setOriginalTitle] = useState(undefined as string | undefined);
    const [isNotifyToggleDisabled, setNotifyToggleDisabled] = useState(false);
    const [userMessage, setUserMessage] = useState("");
    const [reviewPeriodDisabledControl, setReviewPeriodDisabledControl] = useState([] as boolean[]);
    const [documentLoaded, setDocumentLoaded] = useState(false);
    const [allDepartmentNames, setAllDepartmentNames] = useState([] as string[]);
    const [selectedDepartmentNames, setSelectedDepartmentNames] = useState([] as string[]);
    const [documentDepartmentFilter, setDocumentDepartmentFilter] = useState("");
    const [documentDepartmentExpanded, setDocumentDepartmentExpanded] = useState(false);
    const [allDocumentDepartments, setAllDocumentDepartments] = useState([] as DocumentDepartment[]);
    const [selectAllDocumentDepartments, setSelectAllDocumentDepartments] = useState(false);
    const [selectAllTeams, setSelectAllTeams] = useState(false);
    const [confirmProps, setConfirmProps] = useState(null as IConfirmProps | null);
    const [allUsers, setAllUsers] = useState([] as api.User[]);
    const [usersByNameFilter, setUsersByNameFilter] = useState("");
    const [usersByNameExpanded, setUsersByNameExpanded] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([] as api.User[]);
    const [deptTeams, setDeptTeams] = useState([] as string[]);
    const [personnel, setPersonnel] = useState([] as api.User[]);
    const [teamMembers, setTeamMembers] = useState([] as api.User[]);
    const [selectAllPersonnel, setSelectAllPersonnel] = useState(false);
    const [selectedTeams, setSelectedTeams] = useState([] as string[]);
    const [usersByTeamExpanded, setUsersByTeamExpanded] = useState(false);
    const [usersByTeamFilter, setUsersByTeamFilter] = useState("");
    
    type typeahead = InstanceType<typeof Typeahead>;
    const typeAheadRef = React.createRef<typeahead>();

    const documentRef = React.useRef(document);
    const prevDocTypeIdRef = React.useRef<number | undefined>();
    const documentLoadedRef = React.useRef(documentLoaded);

    let deptIds: DocumentDepartmentModel[] = [];
    let personnelList: number[] = [];

    useEffect(() => {
        documentRef.current = document;
    }, [document]);

    useEffect(() => {
        documentLoadedRef.current = documentLoaded;
    }, [documentLoaded]);

    useEffect(() => {
        let mounted = true;
        const departments: string[] = [];
        const mount = async () => {
            const results = await getAllDocumentDepartments();
            if (mounted && results) {
                results.forEach((d) => {
                    if (d.id > 1) {
                        departments.push(d.name)
                    }
                });
                setAllDepartmentNames(departments);
                setAllDocumentDepartments(results);
            }
        };

        mount();

        return () => { mounted = false };
    }, []);

    useEffect(() => {
        let mounted = true;
        const mount = async () => {
            const results = await api.getUsers();
            if (mounted && results?.length) {
                setAllUsers(results);
            };          
        }

        mount();

        return () => { mounted = false };
    }, []);

    useEffect(() => {
        if (!selectAllDocumentDepartments || selectedDepartmentNames.length === 0) {
            return;
        }
        updateTeamsAndPersonnel();
    }, [selectedDepartmentNames]);

    useEffect(() => {
        if (!selectAllTeams) {
            return;
        }
        updateTeamsAndPersonnel();
    }, [selectedTeams]);

    const isAddNew = props.viewType === PageView.AddNew;
    const isEdit = props.viewType === PageView.Edit;
    const isNewVersion = props.viewType === PageView.NewVersion;
    const isRescind = props.viewType === PageView.Rescind;

    var notifyToggleControl: any;
    var reviewRecurringToggleControl: any;

    const updateState = (doc: Document) => {

        doc = setConditionalFieldsAndNotify(doc);

        documentAddEditState.setState(s => {
            s.document = doc;
        });
    }

    const setConditionalFieldsAndNotify = (doc: Document) => {
        var updatedDoc = { ...doc };
        const hasExpiry = (updatedDoc.expiryDate || "") !== "";
        if (hasExpiry && updatedDoc.reviewPeriod !== DocumentReviewPeriodEnum.None) {
            let publishDate = new Date(`${doc.publishDate} ${doc.publishTime || '00:00'}`)
            let expiryDate = new Date(`${doc.expiryDate} ${doc.expiryTime || '00:00'}`)
            let reviewMonths = getMonths(updatedDoc.reviewPeriod);
            let reviewDate = new Date(publishDate.setMonth(publishDate.getMonth() + reviewMonths));
            if (reviewDate > expiryDate) {
                setUserMessage("Review Date can not exceed expiry date");
                updatedDoc.reviewPeriod = DocumentReviewPeriodEnum.None;
                updatedDoc.reviewRecurring = false;
            }
        }

        if (!updatedDoc.requiresAcknowledgementAndNotify) {
            updatedDoc.reviewPeriod = DocumentReviewPeriodEnum.None;
        }

        if (updatedDoc.reviewPeriod == DocumentReviewPeriodEnum.None) {
            updatedDoc.reviewRecurring = false;
        }

        return updatedDoc;
    }

    const updateConditionalFieldsUi = (doc: Document) => {
        if (notifyToggleControl != null) {
            if (isNotifyToggleDisabled) {
                notifyToggleControl.disable();
            }
            else {
                notifyToggleControl.enable();
            }
        }

        if (reviewRecurringToggleControl != null) {
            if (doc.reviewPeriod == DocumentReviewPeriodEnum.None) {
                reviewRecurringToggleControl.disable();
                reviewRecurringToggleControl.disabled = true;
            }
            else {
                reviewRecurringToggleControl.enable();
                reviewRecurringToggleControl.disabled = false;
            }
        }
    }

    const nextAction = () => {
        updateState(document);
        props.nextAction();
    }

    const handleChange = (field: string) => (event: any) => {
        updateState({ ...document, [field]: event.target.value });
    };

    const handleFileChange = (event: any) => {
        if (event) {
            document.file = event.target.files[0];
            document.fileName = document.file!.name;
        } else {
            document.file = undefined;
            document.fileName = undefined;
        }
        updateState(document)
    }

    const handleVersionNumberChange = () => (event: any) => {
        let versionNumber = event.target.value as string;

        //Remove any characters that are not a digit or full stop
        let re = /[^0-9\.]/g;
        versionNumber = versionNumber.replaceAll(re, '');

        updateState({
            ...document,
            versionNumber: versionNumber
        });
    };

    const handleToggle = (field: string) => (val: boolean) => {
        updateState({ ...document, [field]: val });
    }


    const documentTypes = (useSelector(x => x.writableRailDocumentTypes) || []).sort((a, b) => a.label > b.label ? 1 : -1);

    const mode = getUserExistingRulebookMode();
    const cbtcMode = RulebookNameToEnum(mode) === RulebookModeEnum.CBTC;
    const traditionalMode = RulebookNameToEnum(mode) === RulebookModeEnum.Traditional;

    useEffect(() => {

        if (!documentTypes) return;

        const sub = documentAddEditState.subscribe((x: DocumentAddEditState) => {
            const incomingDoc = x.document;
            const localPrevDocTypeId = prevDocTypeIdRef.current;

            const docTypeArray = documentTypes.filter(y => y.typeId === incomingDoc.typeId);

            if (incomingDoc.typeId && docTypeArray.length > 0 && incomingDoc.typeLabel !== docTypeArray[0].label) {
                documentAddEditState.setState(s => {
                    if (s.document.typeId === incomingDoc.typeId) {
                        s.document.typeLabel = docTypeArray[0].label;
                    }
                });
                return; 
            }

            setOriginalTitle(x.originalDocument?.title);
            setDocument(incomingDoc);          

            const newMainDocType = docTypeArray.length > 0 ? docTypeArray[0] : undefined;
            setDocumentType(newMainDocType ? [newMainDocType] : []);

            if (localPrevDocTypeId !== incomingDoc.typeId || !incomingDoc.typeId) {
                let initialSubCategories = newMainDocType?.children || [];
                if (newMainDocType && newMainDocType.typeId === DocumentTypeEnum.NetworkRules) {
                    const operatingSystem = incomingDoc.rulebookOperatingSystem;
                    if (operatingSystem === TraditionalId || operatingSystem === BothId) {
                        // console.log("[useEffect subscription] Main type changed/init. OS is Trad/Both. Filtering NonMBS.");
                        initialSubCategories = initialSubCategories.filter(sub => sub.typeId !== DocumentTypeEnum.NonMBSTerritory);
                    } else {
                        // console.log("[useEffect subscription] Main type changed/init. OS is CBTC. Not filtering NonMBS.");
                    }
                }
                setSubCategories(initialSubCategories as Array<IDocumentTypeItem>);
            }
            prevDocTypeIdRef.current = incomingDoc.typeId;

            setNotifyToggleDisabled(isEdit && x.originalDocument?.requiresAcknowledgementAndNotify === true);

            const vf = validateForm(incomingDoc, props.viewType, false, docTypeArray);
            if (documentLoadedRef.current !== undefined && !documentLoadedRef.current && (props.viewType === PageView.AddNew || (incomingDoc.documentId && incomingDoc.canEdit))) {
                if (!documentLoaded && (props.viewType === PageView.AddNew || (incomingDoc.documentId && incomingDoc.canEdit))) {
                    setDocumentLoaded(true);
                }
            }
            setPageValidation(vf);
            if (props.validateAction) {
                props.validateAction(vf.isValid || false);
            }
        });

        return () => {
            sub.unsubscribe();
            prevDocTypeIdRef.current = undefined; 
        };
    }, [props.viewType, documentTypes, props.validateAction, isEdit]);

    useEffect(() => {
        if (!documentLoaded) {
            return;
        }

        let changesToApply: Partial<Document> = {};
        let needsStateUpdate = false;

        if (props.viewType === PageView.AddNew) {
            changesToApply.versionNumber = '1.0';
            if (traditionalMode) {
                changesToApply.rulebookOperatingSystem = TraditionalId;
            } else if (cbtcMode) {
                changesToApply.rulebookOperatingSystem = CBTCId;
            } else {
                changesToApply.rulebookOperatingSystem = TraditionalId;
            }
            needsStateUpdate = true;
        }

        if (props.viewType === PageView.Rescind) {
            const rescindDefaults: Partial<Document> = { 
                typeId: undefined, typeLabel: undefined,
                subTypeId: undefined, subTypeLabel: undefined,
                title: '', documentNumber: '', versionNumber: "1.0",
                relatedDocuments: [],
                rulebookOperatingSystem: traditionalMode ? TraditionalId : (cbtcMode ? CBTCId : TraditionalId)
            };
            changesToApply = { ...changesToApply, ...rescindDefaults };
            needsStateUpdate = true;
        }

        if (needsStateUpdate && Object.keys(changesToApply).length > 0) {
            documentAddEditState.setState(s => {
                s.document = { ...s.document, ...changesToApply }; 
            });
        }
    // Ensure all variables used in the effect are in the dependency array if they can change and should re-trigger the effect.
    }, [documentLoaded, props.viewType, traditionalMode, cbtcMode]);

    useEffect(() => {
        var newDisabled = [...reviewPeriodDisabledControl];
        var reviewPeriodKeys = Object.keys(DocumentReviewPeriodEnum).map(key => parseInt(key)).filter(k => !isNaN(k));
        reviewPeriodKeys.map(reviewPeriod => {
            newDisabled[reviewPeriod] = false;

            const hasExpiry = (document.expiryDate || "") !== "";

            if (hasExpiry) {
                let publishDate = new Date(`${document.publishDate} ${document.publishTime || '00:00'}`)
                let expiryDate = new Date(`${document.expiryDate} ${document.expiryTime || '00:00'}`)
                let reviewMonths = getMonths(reviewPeriod);
                let reviewDate = new Date(publishDate.setMonth(publishDate.getMonth() + reviewMonths));
                if (reviewDate > expiryDate) {
                    newDisabled[reviewPeriod] = true;
                }
            }
        });
        setReviewPeriodDisabledControl(newDisabled);

    }, [document]);

    useLayoutEffect(() => {
        updateConditionalFieldsUi(document);
    });

    useEffect(() => {
        const sub = documentAddEditState.subscribe((x: DocumentAddEditState) => {
            const incomingDoc = x.document;
            if (incomingDoc.departments !== undefined && incomingDoc.departments.length > 0) {
                if (incomingDoc.departments[0].id === UserDepartmentEnum.All) {
                    setSelectAllDocumentDepartments(true);
                } else if (incomingDoc.departments[0].id !== UserDepartmentEnum.All && incomingDoc.departments.length > 0) {
                    if (incomingDoc.departmentNames)
                        setSelectedDepartmentNames(incomingDoc.departmentNames);
                    if (incomingDoc.departmentTeams !== undefined && incomingDoc.departmentTeams.length > 0) {
                        setSelectedTeams(incomingDoc.departmentTeams);
                    }
                    if (incomingDoc.personnel !== undefined && incomingDoc.personnel.length > 0) {
                        setSelectedUsers(incomingDoc.personnel);
                    } 
                }
            }
        });

        return () => {
            sub.unsubscribe();
        };
    }, []);

    // Look for either document rail book (
    function filterBy(option: any, state: any) {
        const dm = ((document.documentModule == NonRuleBookModuleId) && (option.documentModule != RuleBookModuleId)) ? option.documentModule : document.documentModule;

        if (option.typeId == DocumentTypeEnum.OperatingNoticesAndInstructions) {
            return false;
        }

        if (state.selected.length || !option.label) {
            return option.documentModule == dm;
        }

        const val = (option.label.toLowerCase().indexOf(state.text.toLowerCase()) > -1) && (option.documentModule == dm) ? true : (option.documentModule == dm);
        return val;
    }

    const documentModuleChange = (event: any) => {
        document.documentModule = Number.parseInt(event.target.value);
        document.relatedDocuments = [];

        if (typeAheadRef.current) {
            typeAheadRef.current.clear();
            setDocumentType([]);
            setSubCategories([]);
            document.typeId = undefined;
            document.subTypeId = undefined;
            document.subTypeLabel = undefined;
            document.title = '';
            document.documentNumber = '';
        }
        updateState(document)
    }

    const handleTypeChange = (selected: any) => {
        const currentDocState = document;
        const docType = (selected && selected.length > 0) ? selected[0] as IDocumentTypeItem : undefined;

        let newSubCategories = docType?.children || [];
        let newSubTypeId = currentDocState.subTypeId;
        let newSubTypeLabel = currentDocState.subTypeLabel;

        // Filter sub-categories for "Network Rules" based on operating system
        if (docType && docType.typeId === DocumentTypeEnum.NetworkRules) {
            const operatingSystem = currentDocState.rulebookOperatingSystem;

            // Exclude "Non MBS Territory" if Operating System is Traditional or Both
            if (operatingSystem === TraditionalId || operatingSystem === BothId) {
                newSubCategories = newSubCategories.filter(sub => sub.typeId !== DocumentTypeEnum.NonMBSTerritory);
            }
            // If operatingSystem is CBTCId, "Non MBS Territory" is allowed
        }

        setSubCategories(newSubCategories);

        // If the previously selected sub-type is no longer in the valid list of newSubCategories, reset it.
        if (newSubTypeId && !newSubCategories.find(sc => sc.typeId === newSubTypeId)) {
            newSubTypeId = undefined;
            newSubTypeLabel = newSubCategories.length > 0 ? null : undefined;
        } else if (newSubCategories.length === 0) {
            newSubTypeId = undefined;
            newSubTypeLabel = undefined;
        } else if (newSubCategories.length > 0 && !newSubTypeId && currentDocState.typeId === docType?.typeId) {
            newSubTypeLabel = null;
        }

        var relatedDocs: Array<RelatedDocument> = [];

        if (docType && isRuleBookDocumentType(docType)) { 
            relatedDocs = currentDocState.relatedDocuments || [];
        }

        // Determine title and documentNumber based on the main type or a valid selected sub-type
        const selectedSubTypeForDefaults = newSubTypeId ? newSubCategories.find(sc => sc.typeId === newSubTypeId) : undefined;
        const titleDefaultSource = selectedSubTypeForDefaults || docType;

        let title = getDefaultTitle(titleDefaultSource);
        let documentNumber = getDefaultDocumentNumberTitle(titleDefaultSource);

        // If main document type is cleared, also clear sub-type and related fields
        if (!docType) {
            newSubTypeId = undefined;
            newSubTypeLabel = undefined;
            title = '';
            documentNumber = '';
        }

        updateState({
            ...currentDocState,
            typeId: docType?.typeId,
            typeLabel: docType?.label,
            relatedDocuments: relatedDocs,
            subTypeId: newSubTypeId,
            subTypeLabel: newSubTypeLabel,
            title: title,
            documentNumber: documentNumber
        });
    };

    const handleSubTypeChange = (event: any) => {
        const docType = subCategories.find(x => x.typeId == (event.target.value as number));
        let title = getDefaultTitle(docType);
        let documentNumber = getDefaultDocumentNumberTitle(docType);

        updateState({
            ...document,
            subTypeId: docType?.typeId,
            subTypeLabel: docType?.label,
            title: title,
            documentNumber: documentNumber
        });
    }

    const removeRelatedDocument = (id: number) => {
        updateState({
            ...document,
            relatedDocuments: (document.relatedDocuments || []).filter(d => d.id !== id)
        })
    };

    var nextButtonText = "Continue";

    switch (props.viewType) {
        case PageView.Rescind:
            nextButtonText = "Rescind";
            break;
        case PageView.Edit:
            nextButtonText = "Update details";
            break;
        case PageView.NewVersion:
            nextButtonText = "Add new version";
            break;
        default:
            break;
    }

    const onNextButtonClick = async () => {
        const req = {
            id: document.documentId,
            document: document,
            pageNumber: 1,
            viewType: props.viewType
        } as IDocumentValidationRequest;

        // validate the form locally
        const docType = documentTypes.filter(y => y.typeId === document.typeId);
        const pv = validateForm(document, props.viewType, true, docType);

        // get any server side validation errors
        await validateDocument(req).then(response => {
            if (response) {
                if (response.errors["documentNumber"]) {
                    pv.documentNumberValidation = { display: true, message: response.errors["documentNumber"] }
                    pv.isValid = false;
                }

                if (pv.isValid) {
                    nextAction();
                } else {
                    setPageValidation(pv);
                }
            }
        });
    };

    type ReviewPeriodSelectionProps = {
        period: DocumentReviewPeriodEnum
    }

    const ReviewPeriodSelection = (props: ReviewPeriodSelectionProps) => {
        return (
            <FormGroup className="pr-4" check>
                <Label check>
                    <Input
                        type="radio"
                        name="reviewPeriod"
                        value={props.period}
                        checked={document.reviewPeriod == props.period}
                        disabled={reviewPeriodDisabledControl[props.period]}
                        onChange={handleChange("reviewPeriod")}
                    />
                    {documentReviewPeriodDisplay(props.period)}
                </Label>
            </FormGroup>
        );
    }

    const handleExpiryDateChange = (event: any) => {
        let newDocState = { ...document, ['expiryDate']: event.target.value };
        let expiryDate = new Date(`${event.target.value}T00:00:00`).setHours(0, 0, 0, 0);
        let currentDate = new Date().setHours(0, 0, 0, 0);
        if (expiryDate > currentDate) {
            newDocState['expiryTime'] = '23:59';
        }
        updateState(newDocState);
    }

    const documentOSChange = (event: any) => {
        const currentDocState = document;
        const newOperatingSystem = Number.parseInt(event.target.value);

        let newDoc = { ...currentDocState, rulebookOperatingSystem: newOperatingSystem };

        let newSubCategoriesLog = [...subCategories]; 

        if (newDoc.typeId === DocumentTypeEnum.NetworkRules) {
            const networkRulesDocType = documentTypes.find(dt => dt.typeId === DocumentTypeEnum.NetworkRules);
            let originalNetworkRulesSubCategories = networkRulesDocType?.children || [];

            if (newOperatingSystem === TraditionalId || newOperatingSystem === BothId) {
                console.log("[documentOSChange] Filtering: OS is Traditional or Both. Attempting to filter out NonMBSTerritory (Enum ID:", DocumentTypeEnum.NonMBSTerritory + ").");
                const originalCount = originalNetworkRulesSubCategories.length;
                newSubCategoriesLog = originalNetworkRulesSubCategories.filter(sub => {
                    return sub.typeId !== DocumentTypeEnum.NonMBSTerritory;
                });
            } else { // CBTCId
                newSubCategoriesLog = originalNetworkRulesSubCategories;
            }
            setSubCategories(newSubCategoriesLog); 

            if (newDoc.subTypeId && !newSubCategoriesLog.find(sc => sc.typeId === newDoc.subTypeId)) {
                newDoc.subTypeId = undefined;
                newDoc.subTypeLabel = newSubCategoriesLog.length > 0 ? null : undefined;

                const mainDocTypeForDefaults = documentTypes.find(dt => dt.typeId === newDoc.typeId);
                newDoc.title = getDefaultTitle(mainDocTypeForDefaults); 
                newDoc.documentNumber = getDefaultDocumentNumberTitle(mainDocTypeForDefaults);
            }
        }
        updateState(newDoc);
    };

    const toggleItem = <T,>(
        item: T,
        arr: T[],
        comparerPredicate: (value: T) => boolean,
        setter: (value: T[]) => void
    ): boolean => {
        const idx = arr.findIndex(comparerPredicate);

        var result = false;

        if (idx === -1) {
            result = true;
            arr.push(item);
        } else {
            arr.splice(idx, 1);
        }

        setter(arr);
        return result;
    };

    const updateTeamsAndPersonnel = () => {
        // Update Teams
        let departments: (number | undefined)[] = getDepts();
        const usersForSelectedDepts = allUsers.filter(f => departments.includes(f.deptId));
        const teamsForSelectedDepts = usersForSelectedDepts.map(t => t.team);
        const uniqueTeamsForSelectedDepts = teamsForSelectedDepts.filter((item, index) => teamsForSelectedDepts.indexOf(item) === index);

        setDeptTeams(uniqueTeamsForSelectedDepts);
        let updatedTeams: string[] = []; // All team when nothing is selected
        if (!selectAllTeams) {
            updatedTeams = selectedTeams.filter(t => uniqueTeamsForSelectedDepts.includes(t));
        }
        
        setSelectedTeams(updatedTeams);

        // Update personnel
        const teamPersonnel = allUsers.filter(f => uniqueTeamsForSelectedDepts.includes(f.team) && departments.includes(f.deptId));

        setPersonnel(teamPersonnel);
        let updatedPersonnel: User[] = [];
        if (!selectAllPersonnel) {
            updatedPersonnel = selectedUsers.filter(u => teamPersonnel.includes(u));
        }
        
        setSelectedUsers(updatedPersonnel);
        personnelList = updatedPersonnel?.map(u => u.id);

        selectedDepartmentNames.forEach((deptName) => {
            allDocumentDepartments.forEach((dept) => {
                if (deptName === dept.name) {
                    if (!deptIds.find((d) => d.id === dept.id)) {
                        deptIds.push({ id: dept.id, name: deptName } as DocumentDepartmentModel);
                    }
                }
            });
        });

        let updatedDoc = { ...document, departments: deptIds, departmentNames: selectedDepartmentNames, departmentTeams: updatedTeams, personnelId: personnelList, personnel: updatedPersonnel };
        updateState(updatedDoc);
    }

    const userDepartmentOptionsAdded = () => {
        if (selectAllDocumentDepartments) {
            setSelectAllDocumentDepartments(false);
        }        
        let updatedDoc = { ...document, departments: deptIds, departmentNames: selectedDepartmentNames};
        updateState(updatedDoc);
    }   

    const toggleDepartment = (dpt: string): void => {
        if (toggleItem(dpt, selectedDepartmentNames, d => { return d === dpt }, setSelectedDepartmentNames) === true) {
            const idx = selectedDepartmentNames.indexOf('All');
            if (idx !== -1) {
                selectedDepartmentNames.splice(idx, 1);
            }
            userDepartmentOptionsAdded();
        }
        
        updateTeamsAndPersonnel();
    };

    const getDepts = () => {
        let depts: (number | undefined)[] = [];
        if (selectedDepartmentNames.length > 0) {
            depts = allDocumentDepartments.filter(d => selectedDepartmentNames.includes(d.name)).map(m => m.id);            
        } else {
            depts = [];
        }
        return depts;
    }

    const userTeamsOptionAdded = () => {
        if (selectAllTeams) {
            setSelectAllTeams(false);
        }

        let updatedDoc = { ...document, departmentTeams: selectedTeams };
        updateState(updatedDoc);
    }

    useEffect(() => {
        if (selectAllTeams || selectedTeams.length === 0) {
            setTeamMembers(personnel);
        } else {
            const team = personnel.filter(p => selectedTeams.includes(p.team));
            setTeamMembers(team);
        }
    }, [deptTeams, selectAllTeams]);

    const toggleTeams = (dpt: string): void => {
        if (toggleItem(dpt, selectedTeams, d => { return d === dpt }, setSelectedTeams) === true) {
            userTeamsOptionAdded();
        }

        // Update personnel
        let teamPersonnel: User[] = [];
        const depts = getDepts(); 
        if (selectedTeams.length === 0) {
            teamPersonnel = allUsers.filter(f => depts.includes(f.deptId));
            setPersonnel(teamPersonnel);
        } else {
            // Id 1 for All departments
            teamPersonnel = allUsers.filter(f => selectedTeams.includes(f.team) && (depts[0] !== 1 ? depts.includes(f.deptId) : true ));
            setPersonnel(teamPersonnel);
        }

        let selectedUsersInSelectedTeam: User[] = [];
        if (selectedUsers.length > 0) {
            selectedUsersInSelectedTeam = selectedUsers.filter(p => teamPersonnel.includes(p));
            setSelectedUsers(selectedUsersInSelectedTeam);
        }

        personnelList = selectedUsersInSelectedTeam.map(u => u.id);
        let updatedDoc = { ...document, departmentTeams: selectedTeams, personnelId: personnelList, personnel: selectedUsersInSelectedTeam };
        updateState(updatedDoc);
    };

    const userPersonnelOptionAdded = () => {
        if (selectAllPersonnel) {
            setSelectAllPersonnel(false);
        }
        personnelList = selectedUsers.map(u => u.id)
        let updatedDoc = { ...document, personnelId: personnelList, personnel: selectedUsers };
        updateState(updatedDoc);
    }

    const togglePersonnel = (usr: api.User) => {
        if (toggleItem(usr, selectedUsers, u => { return u.id === usr.id }, setSelectedUsers) === true) {
            userPersonnelOptionAdded();
        }

        personnelList = selectedUsers.map(u => u.id)
        let updatedDoc = { ...document, personnelId: personnelList, personnel: selectedUsers };
        updateState(updatedDoc);
    };

    const stringItemFilter = (item: string, filterText: string) => {
        return item?.toLowerCase().indexOf(filterText.toLowerCase()) > -1;
    };

    const filterStringArray = (name: string, items?: string[]) => {
        if (!items) return [] as string[];

        const result = items.filter(v => stringItemFilter(v, name));

        return result;
    };

    const confirm = async (message: string, opts?: string[], defaultOption?: string, cancelOption?: string): Promise<string> => {
        return new Promise<string>((resolve) => {
            setConfirmProps({
                message: message,
                options: opts ?? ["OK", "Cancel"],
                defaultOption: defaultOption,
                setResult: (value) => {
                    setConfirmProps({} as IConfirmProps);
                    resolve(value);
                }
            });
        });
    };

    const setSelectAllDocumentDepartmentsAndClearSelections = (value: boolean) => {
        if (value) {
            confirm("Are you sure you want to include all document departments?", ["All Departments", "Cancel"], "All Departments").then(result => {
                if (result === "All Departments") {
                    setSelectAllDocumentDepartments(true);
                    setSelectedDepartmentNames(['All']);
                } else {
                    setSelectAllDocumentDepartments(false);
                }
            });
        } else {
            setSelectAllDocumentDepartments(value);
            setSelectedDepartmentNames([]);
            setSelectedTeams([]);
            setDeptTeams([]);
            setSelectedUsers([]);
            setPersonnel([]);
        }
    };

    useEffect(() => {
        const sub = documentAddEditState.subscribe((x: DocumentAddEditState) => {
            const incomingDoc = x.document;

            if (incomingDoc !== undefined && 'departments' in incomingDoc) {
                if (incomingDoc.departments!.length > 0 && allDocumentDepartments.length > 0 && allUsers.length > 0) {
                    let depts: (number | undefined)[];
                    if (incomingDoc.departments![0].name === 'All') {
                        depts = allDocumentDepartments.map(d => d.id)
                    } else {
                        const deptNames = incomingDoc.departments?.map(d => d.name);
                        depts = allDocumentDepartments.filter(d => deptNames?.includes(d.name)).map(m => m.id);
                    }
                    const usersForSelectedDepts = allUsers.filter(f => depts.includes(f.deptId));
                    const teamsForSelectedDepts = usersForSelectedDepts.map(t => t.team);
                    const uniqueTeamsForSelectedDepts = teamsForSelectedDepts.filter((item, index) => teamsForSelectedDepts.indexOf(item) === index);
                    setDeptTeams(uniqueTeamsForSelectedDepts);
                    setSelectedTeams(incomingDoc?.departmentTeams || []);

                    // Update personnel
                    const teamPersonnel = allUsers.filter(f => uniqueTeamsForSelectedDepts.includes(f.team) && depts.includes(f.deptId));
                    setPersonnel(teamPersonnel);
                    setSelectedUsers(incomingDoc?.personnel || [])
                }
            }           
        });

        return () => {
            sub.unsubscribe();
        };
    }, [allDocumentDepartments, allUsers]);

    const setSelectAllTeamsAndClearSelections = (value: boolean) => {
        if (value) {
            confirm("Are you sure you want to include all teams?", ["All Teams", "Cancel"], "All Teams").then(result => {
                if (result === "All Teams") {
                    setSelectAllTeams(true);
                    setSelectedTeams([]);
                }
            });
        }
    };

    const setSelectAllPersonnelAndClearSelections = (value: boolean) => {
        if (value) {
            confirm("Are you sure you want to include all personnel in the selected team(s)?", ["All Personnel", "Cancel"], "All Personnel").then(result => {
                if (result === "All Personnel") {
                    setSelectAllPersonnel(true);
                    setSelectedUsers([]);
                }
            });
        }
    };

    const userNameItemFilter = (item: api.User, filterText: string) => {
        const lcName = filterText.toLowerCase();

        return (
            (item.fullName).toLowerCase().indexOf(lcName) > -1
            || (item.email?.toLowerCase().indexOf(lcName) > -1)
        );
    };

    const userNameFilter = (name: string, users?: api.User[]) => {
        if (!users) {
            return [] as api.User[];
        }

        return users.filter(u => userNameItemFilter(u, name));
    };

    const deselectUserItems = (items: api.User[], stateItems: api.User[], setter: (items: api.User[]) => void) => {
        const newUsers = [...stateItems].filter(user => !items.includes(user));
        setter(newUsers);
    };

    const deselectUsers = (items: api.User[]) => {
        deselectUserItems(items, selectedUsers, setSelectedUsers);
    }

    return (
        <React.Fragment key={document.documentId}>
            <ModalBody className="pb-4 ml-5 mr-5">                
                <FormGroup>

                    <h3>{`Document details${originalTitle ? `: ${originalTitle}` : ''}`}</h3>

                    {(isAddNew || isRescind) &&
                        <FormGroup>
                            <Label htmlFor="doc-rulebook-mode">Operating System</Label>
                            <div>                                
                                <FormGroup tag="fieldset" className="form-check-inline pt-2">
                                    <FormGroup check>
                                        <Label check>
                                            <Input type="radio"
                                                value={TraditionalId}
                                                onChange={documentOSChange}
                                                checked={TraditionalId === document.rulebookOperatingSystem}
                                                disabled={cbtcMode}
                                                name="operatingSystemRadio" />
                                            <span> Rulebook</span>
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check className="pl-5">
                                        <Label check>
                                            <Input type="radio"
                                                value={CBTCId}
                                                onChange={documentOSChange}
                                                checked={CBTCId === document.rulebookOperatingSystem}
                                                disabled={traditionalMode}
                                                name="operatingSystemRadio" />
                                            <span> MBS Rulebook</span>
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check className="pl-5">
                                        <Label check>
                                            <Input type="radio"
                                                value={BothId}
                                                onChange={documentOSChange}
                                                checked={BothId === document.rulebookOperatingSystem}
                                                disabled={false}
                                                name="operatingSystemRadio" />
                                            <span> Both Rulebooks</span>
                                        </Label>
                                    </FormGroup>
                                </FormGroup>
                            </div>

                            <Label htmlFor="doc-type-combo">Module</Label>
                            <div>
                                <FormGroup tag="fieldset" className="form-check-inline pt-2">
                                    <FormGroup check>
                                        <Label check>
                                            <Input type="radio"
                                                value={NonRuleBookModuleId}
                                                onChange={documentModuleChange}
                                                checked={document.documentModule !== RuleBookModuleId}
                                                disabled={documentTypes.filter(y => y.typeId !== RuleBookModuleId).length == 0}
                                                name="docTypeRadio" />
                                            <span> Rail Document</span>
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check className="pl-5">
                                        <Label check>
                                            <Input type="radio"
                                                value={RuleBookModuleId}
                                                onChange={documentModuleChange}
                                                checked={document.documentModule === RuleBookModuleId}
                                                disabled={documentTypes.filter(y => y.typeId === RuleBookModuleId).length == 0}
                                                name="docTypeRadio" />
                                            <span> Rulebook</span>
                                        </Label>
                                    </FormGroup>
                                </FormGroup>
                            </div>
                            <FormGroup>
                                <Label htmlFor="doc-type-combo">Document type</Label>
                                <Row>
                                    <Col sm={12} md={7}>
                                        {/*
                                            Map documentTypes to change the display label based on Operating System,
                                            but keep the original typeId and label for state updates.
                                        */}
                                        <TypeaheadComponent
                                            filterBy={filterBy}
                                            id="doc-type-combo"
                                            onChange={handleTypeChange}
                                            ref={typeAheadRef}
                                            selected={documentType.map(docType => {
                                                let displayLabel = docType.label;
                                                const isNetwork = docType.label.startsWith('Network ');
                                                if (isNetwork) {
                                                    if (document.rulebookOperatingSystem === CBTCId) {
                                                        displayLabel = docType.label.replace('Network ', 'Operational ');
                                                    } else if (document.rulebookOperatingSystem === BothId) {
                                                        displayLabel = docType.label.replace('Network ', 'Operational/Network ');
                                                    }
                                                    // If TraditionalId, displayLabel remains original 'Network ...'
                                                }

                                                // Return a new object with the potentially modified label for display
                                                return {
                                                    ...docType, // Keep all original properties (including original typeId and label)
                                                    label: displayLabel // Override the label property specifically for Typeahead display
                                                };
                                            })}
                                            options={documentTypes.map(docType => {
                                                let displayLabel = docType.label;
                                                const isNetwork = docType.label.startsWith('Network ');
                                                if (isNetwork) {
                                                    if (document.rulebookOperatingSystem === CBTCId) {
                                                        displayLabel = docType.label.replace('Network ', 'Operational ');
                                                    } else if (document.rulebookOperatingSystem === BothId) {
                                                        displayLabel = docType.label.replace('Network ', 'Operational/Network ');
                                                    }
                                                    // If TraditionalId, displayLabel remains original 'Network ...'
                                                }

                                                // Return a new object with the potentially modified label for display
                                                return {
                                                    ...docType, // Keep all original properties (including original typeId and label)
                                                    label: displayLabel // Override the label property specifically for Typeahead display
                                                };
                                            })}
                                            inputProps={{ required: true }}
                                            isInvalid={pageValidation.documentTypeValidation?.display}
                                            placeholder="Select document type">
                                            {({ isMenuShown, toggleMenu }: any) => (
                                                <ToggleButton isOpen={isMenuShown} isInvalid={pageValidation.documentTypeValidation?.display} onClick={() => toggleMenu()} />
                                            )}
                                        </TypeaheadComponent>
                                        {/* Hack to display validation message for typeahead */}
                                        {
                                            pageValidation.documentTypeValidation?.display &&
                                            <div className='validation-text'>{pageValidation.documentTypeValidation?.message}</div>
                                        }
                                    </Col>
                                </Row>
                            </FormGroup>
                            {(subCategories.length > 0) &&
                                <>
                                    <Label htmlFor="docSubCategoryRadio">Document sub-type</Label>
                                    <div>
                                        <FormGroup tag="fieldset" className="form-check-inline">
                                            {
                                                subCategories.map((c, i) => (
                                                    <FormGroup key={i} className="pr-4" check>
                                                        <Label check className={pageValidation.subTypeValidation?.display ? 'invalid-field' : ''} >
                                                            <Input
                                                                type="radio"
                                                                value={c.typeId}
                                                                onChange={handleSubTypeChange}
                                                                checked={c.typeId == document.subTypeId}
                                                                name="docSubCategoryRadio" />{' '}
                                                            {c.label}
                                                        </Label>
                                                    </FormGroup>
                                                ))
                                            }
                                        </FormGroup>
                                        {
                                            pageValidation.subTypeValidation?.display &&
                                            <div className='validation-text'>{pageValidation.subTypeValidation?.display}</div>
                                        }
                                    </div>
                                </>
                            }                            
                        </FormGroup>                        
                    }
                    <FormGroup>
                        <FormGroup>
                            {(isNewVersion) ?
                                <></>
                                :
                                <>
                                    <Label htmlFor="doc-department-combo">Document department</Label>
                                    <Row>
                                        <Col sm={12} md={7}>
                                            <div className="body top-border">
                                                <LabelledCheckbox
                                                    checkedValue={selectAllDocumentDepartments}
                                                    toggle={() => { setSelectAllDocumentDepartmentsAndClearSelections(!selectAllDocumentDepartments); }}>Select all departments</LabelledCheckbox>
                                            </div>
                                            <List<string>
                                                listItemType={StringListItem}
                                                filterText={documentDepartmentFilter}
                                                setFilterText={setDocumentDepartmentFilter}
                                                expanded={documentDepartmentExpanded}
                                                setExpanded={setDocumentDepartmentExpanded}
                                                dataSource={allDepartmentNames}
                                                searchDelayMs={1}
                                                displayLoadingData={true}
                                                refreshFilterOnDataSourceChange={true}
                                                buildKey={item => item}
                                                filter={filterStringArray}
                                                itemFilter={stringItemFilter}
                                                toggleSelected={toggleDepartment}
                                                noResultsMessage="No departments found"
                                                filterTextPlaceholder="Enter department name"
                                                invalid={pageValidation.documentDepartmentValidation?.display}
                                                selected={document.departmentNames || []} />
                                            {
                                                pageValidation.documentDepartmentValidation?.display &&
                                                <div className='validation-text'>{pageValidation.documentDepartmentValidation?.message}</div>
                                            }
                                            <span>
                                                {selectedDepartmentNames[0] !== 'All' &&
                                                    <Chips prefix="Department" values={selectedDepartmentNames} removeItem={toggleDepartment} />
                                                }                                                
                                                &nbsp;
                                                {selectAllDocumentDepartments &&
                                                    <Chip onDelete={() => { setSelectAllDocumentDepartmentsAndClearSelections(false); }} label={<><b>Department: </b>All</>}></Chip>
                                                }
                                                &nbsp;
                                            </span>
                                            {confirmProps &&
                                                <ConfirmationBox {...confirmProps} />
                                            }
                                        </Col>
                                    </Row>                                    
                                </>
                            }
                        </FormGroup>
                        <FormGroup>
                            {(isNewVersion) ?
                                <></>
                                :
                                <>
                                    <Label htmlFor="doc-team-combo">Document team</Label>
                                    <Row>
                                        <Col sm={12} md={7}>
                                            <div className="body top-border">
                                                <LabelledCheckbox
                                                    checkedValue={selectAllTeams || selectedTeams.length === 0}
                                                    toggle={() => { setSelectAllTeamsAndClearSelections(!selectAllTeams); }}>Select all teams</LabelledCheckbox>
                                            </div>
                                            <List<string>
                                                listItemType={StringListItem}
                                                filterText={usersByTeamFilter}
                                                setFilterText={setUsersByTeamFilter}
                                                expanded={usersByTeamExpanded}
                                                setExpanded={setUsersByTeamExpanded}
                                                dataSource={deptTeams}
                                                searchDelayMs={1}
                                                refreshFilterOnDataSourceChange={true}
                                                buildKey={item => item}
                                                filter={filterStringArray}
                                                itemFilter={stringItemFilter}
                                                toggleSelected={toggleTeams}
                                                noResultsMessage="No teams found"
                                                filterTextPlaceholder="Enter search text (Document department(s) must be selected first)"
                                                selected={document.departmentTeams || []} />
                                            <span>
                                                <Chips prefix="Team" values={selectedTeams} removeItem={toggleTeams} />
                                                &nbsp;
                                                {(selectAllTeams || selectedTeams.length === 0) &&
                                                    <Chip onDelete={() => { setSelectAllTeamsAndClearSelections(false); }} label={<><b>Team: </b>All</>}></Chip>
                                                }
                                                &nbsp;
                                            </span>
                                            {confirmProps &&
                                                <ConfirmationBox {...confirmProps} />
                                            }
                                        </Col>
                                    </Row>
                                </>
                            }
                        </FormGroup>
                        <FormGroup>
                            {(isNewVersion) ?
                                <></>
                                :
                                <>
                                    <Label htmlFor="doc-personnel-combo">Document personnel</Label>
                                    <Row>
                                        <Col sm={12} md={7}>
                                            <div className="body top-border">
                                                <LabelledCheckbox
                                                    checkedValue={selectAllPersonnel || selectedUsers.length === 0}
                                                    toggle={() => { setSelectAllPersonnelAndClearSelections(!selectAllPersonnel); }}>Select all personnel in teams above</LabelledCheckbox>
                                            </div>
                                            <List<api.User>
                                                dataSource={teamMembers}
                                                searchDelayMs={1}
                                                refreshFilterOnDataSourceChange={true}
                                                listItemType={UserListItem}
                                                filterText={usersByNameFilter}
                                                setFilterText={setUsersByNameFilter}
                                                expanded={usersByNameExpanded}
                                                setExpanded={setUsersByNameExpanded}
                                                buildKey={item => item.id}
                                                filter={userNameFilter}
                                                toggleSelected={togglePersonnel}
                                                deselectItems={deselectUsers}
                                                noResultsMessage="No users found"
                                                filterTextPlaceholder="Enter first name, last name or email address"
                                                selected={selectedUsers} />
                                            <span>
                                                <UserChips prefix="Personnel" values={selectedUsers} removeItem={togglePersonnel} />
                                                &nbsp;
                                                {(selectAllPersonnel || selectedUsers.length === 0) &&
                                                    <Chip onDelete={() => { setSelectAllPersonnelAndClearSelections(false); }} label={<><b>Personnel: </b>All</>}></Chip>
                                                }
                                                &nbsp;
                                            </span>
                                            {confirmProps &&
                                                <ConfirmationBox {...confirmProps} />
                                            }
                                        </Col>
                                    </Row>
                                </>
                            }
                        </FormGroup>
                        {(isNewVersion) ?
                            <></>
                            :
                            <>
                                <Label for="doc-title">Document title</Label>
                                <Input
                                    id="doc-title"
                                    type="text"
                                    key="doc-title"
                                    invalid={pageValidation.titleValidation?.display}
                                    required={true}
                                    disabled={documentType.length < 1}
                                    maxLength={100}
                                    placeholder="Enter document title (max. 100 characters)"
                                    onChange={handleChange("title")}
                                    value={document.title} />
                                <FormFeedback>{pageValidation.titleValidation?.message}</FormFeedback>
                            </>}
                    </FormGroup>
                    <Row>
                        {(isNewVersion) ?
                            <></>
                            :
                            <Col sm="6">
                                
                                <ToolTipLabel label="Document number" text={toolTip.documentNumber}  /> 
                                <Input
                                    id="doc-number"
                                    onChange={handleChange("documentNumber")}
                                    name="doc-number"
                                    maxLength={20}
                                    minLength={7}
                                    disabled={documentType.length < 1}
                                    invalid={pageValidation.documentNumberValidation?.display}
                                    type="text"
                                    placeholder="Enter document number"
                                    value={document.documentNumber} />

                                <FormFeedback>{pageValidation.documentNumberValidation?.message}</FormFeedback>
                            </Col>
                        }
                        <Col sm="6">

                            <ToolTipLabel label="Version number" text={toolTip.versionNumber} /> 
                            <Input id="doc-version"
                                onChange={handleVersionNumberChange()}
                                name="doc-version"
                                type="text"
                                placeholder="Enter version number"
                                invalid={pageValidation.versionNumberValidation?.display}
                                value={document.versionNumber} />
                            <FormFeedback>{pageValidation.versionNumberValidation?.message}</FormFeedback>
                        </Col>
                    </Row>                    
                </FormGroup>
                <RelatedDocumentsSection document={document} deleteAction={removeRelatedDocument} />
                <h3>Date and time</h3>
                {
                    ((isEdit || isRescind) && document.publishDate) &&
                    <FormGroup>
                        <Label >Published Date</Label>
                        <Row>
                            <Col>
                                <Input type="date" id="publishedDate" disabled={true} defaultValue={document.publishDate} />
                            </Col>
                            <Col>
                                <Input type="time" id="publishedTime" disabled={true} defaultValue={document.publishTime} />
                            </Col>
                        </Row>
                    </FormGroup>
                }
                <FormGroup>
                    <ToolTipLabel label="Set document 'effective from' date and time:" text={toolTip.effectiveDate} />
                    <Row>
                        <Col>
                            <Input type="date" id="effectiveDate" invalid={pageValidation.effectiveDateValidation?.display} min={toISOLocalDate(new Date())} onChange={handleChange("effectiveFromDate")} value={document.effectiveFromDate} />
                            <FormFeedback>{pageValidation.effectiveDateValidation?.message}</FormFeedback>
                        </Col>
                        <Col>
                            <Input type="time" id="effectiveTime" step={60} onChange={handleChange("effectiveFromTime")} value={document.effectiveFromTime} />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup>
                    <ToolTipLabel label="Set expiry date and time if applicable:" text={toolTip.expiryDate} />

                    <Row>
                        <Col>
                            <Input type="date" id="expiryDate" invalid={pageValidation.expireDateValidation?.display} min={toISOLocalDate(new Date())} onChange={handleExpiryDateChange} value={document.expiryDate} />
                            <FormFeedback>{pageValidation.expireDateValidation?.message}</FormFeedback>
                        </Col>
                        <Col>
                            <Input type="time" id="expiryTime" step={60} onChange={handleChange("expiryTime")} value={document.expiryTime} />
                        </Col>
                    </Row>
                </FormGroup>
                <hr />
                <h3>Notification and acknowledgement</h3>
                <FormGroup className={isNotifyToggleDisabled ? "disable-toggle" : ""}>
                    <Label>Notify users and seek acknowledgement of the document</Label>
                    <Toggle
                        checked={document.requiresAcknowledgementAndNotify}
                        onlabel='YES'
                        onstyle='light'
                        offlabel='NO'
                        offstyle='light'
                        style='w-40 mx-3 toggle'
                        size="sm"
                        onChange={handleToggle('requiresAcknowledgementAndNotify')}
                        ref={(input) => { notifyToggleControl = input }}
                    />
                </FormGroup>
                <Label>If required, set a review date for the document to be re-acknowledged:<ToolTipButton text={toolTip.reviewPeriod} /></Label>
                <div>
                    <FormGroup tag="fieldset" className="form-check-inline" disabled={!document.requiresAcknowledgementAndNotify}>
                        <ReviewPeriodSelection period={DocumentReviewPeriodEnum.None} />
                        <ReviewPeriodSelection period={DocumentReviewPeriodEnum.Months6} />
                        <ReviewPeriodSelection period={DocumentReviewPeriodEnum.Months12} />
                        <ReviewPeriodSelection period={DocumentReviewPeriodEnum.Months18} />
                        <ReviewPeriodSelection period={DocumentReviewPeriodEnum.Months24} />
                        <ReviewPeriodSelection period={DocumentReviewPeriodEnum.Months36} />
                    </FormGroup>
                </div>
                <FormGroup tag="fieldset" className="form-check-inline">
                    <Label check className={document.reviewPeriod == DocumentReviewPeriodEnum.None ? "disable-toggle" : ""}>
                        <label>Recurring:</label>
                        <Toggle
                            checked={document.reviewRecurring}
                            onlabel='YES'
                            onstyle='light'
                            offlabel='NO'
                            offstyle='light'
                            style='w-40 mx-3 toggle'
                            size="sm"
                            onChange={handleToggle('reviewRecurring')}
                            ref={(input) => { reviewRecurringToggleControl = input }}
                        >
                        </Toggle>
                    </Label>
                </FormGroup>
                <DocumentFileUploadSection document={document} viewType={props.viewType} pageValidation={pageValidation} onFileChange={handleFileChange} />
                <hr />
                <h3>Release notes (optional):  <ToolTipButton text={toolTip.releaseNotes} /></h3>

                <Input
                    type="textarea"
                    name="text"
                    id="exampleText"
                    placeholder="Enter release notes here (max. 500 characters)"
                    onChange={handleChange("releaseNotes")}
                    defaultValue={document.releaseNotes}
                    maxLength={500}
                />
                {isRescind &&
                    <>
                    <hr />
                    <h3>Reason for rescinding:  <ToolTipButton text={toolTip.rescindDocumentReason} /></h3>
                
                    <Input
                        type="textarea"
                        name="text"
                        id="exampleText"
                        invalid={pageValidation.rescindDocumentReasonValidation?.display}
                        required={true}
                        placeholder="Enter reason for rescinding document (max. 500 characters)"
                        onChange={handleChange("rescindDocumentReason")}
                        defaultValue={document.rescindDocumentReason}
                        maxLength={500}
                    />
                    <FormFeedback>{pageValidation.rescindDocumentReasonValidation?.message}</FormFeedback>
                    </>
                }
                <div className="pb-3" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button className="btn-secondary pr-4 pl-4 m-4" onClick={props.closeAction}>Cancel</Button>
                    <Button className="btn-primary pr-4 pl-4 m-4" onClick={onNextButtonClick}>{nextButtonText}</Button>
                </div>
                <InfoModal isOpen={userMessage !== ""} closeAction={() => setUserMessage("")} text={userMessage} />
            </ModalBody>

        </React.Fragment >
    );
}
